import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoadingComponent } from '@/app/core/services/loading';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingComponent],
  host: {
    // Ensure root component fills the entire viewport
    class: 'flex min-h-full w-full flex-auto flex-col',
  },
  template: `
    <app-loading />
    <router-outlet />
  `,
})
export class App {}
